import React from "react";
import * as Icon from "@phosphor-icons/react";
import { useInView } from "react-intersection-observer";

function Footer() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <footer
      ref={ref}
      className={`footer-wrapper fade-up ${inView ? "visible" : ""}`}
    >
      <div className="footer-grid">

        <div className="footer-col">
          <a href="/" className="footer-logo">
            <img
              src={require("../../assets/Images/Logoname.png")}
              alt="Aelitez Logo"
            />
          </a>

          <div className="footer-contact">
            <p><strong>Mail:</strong> <a href="mailto:aelitez10@gmail.com">aelitez10@gmail.com</a></p>
            <p><strong>Phone:</strong> <a href="tel:+919391460554">+91 9391460554</a></p>
            <p>
              <strong>Address:</strong><br />
              No. 49A, ABT Road,<br />
              Karuvampalayam, Tirupur – 641604
            </p>
          </div>
        </div>

        <div className="footer-col">
          <p className="footer-title">Quick Shop</p>
          <a href="/shop?gender=women" className="footer-link">Women</a>
          <a href="/shop?gender=kids" className="footer-link">Kids</a>
          <a href="/shop?category=Maternity Wear" className="footer-link">Maternity Wear</a>
          <a href="/shop?category=Lounge Wear" className="footer-link">Lounge Wear</a>
          <a href="/shop?category=Plazzo" className="footer-link">Plazoo Pants</a>
        </div>

        <div className="footer-col">
          <p className="footer-title">Customer Service</p>
          <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
          <a href="/terms-and-conditions" className="footer-link">Terms & Conditions</a>
          <a href="/shipping-policy" className="footer-link">Shipping Policy</a>
          <a href="/exchange-return-policy" className="footer-link">Exchange Policy</a>
          <a href="/refund-policy" className="footer-link">Return & Refund</a>
        </div>

      </div>

      <div className="footer-bottom">
        <p>©️ 2025 Aelitez. All Rights Reserved.</p>

        <div className="footer-social">
          <a href="#"><Icon.FacebookLogo size={22} weight="fill" /></a>
          <a href="#"><Icon.InstagramLogo size={22} weight="fill" /></a>
          <a href="#"><Icon.TwitterLogo size={22} weight="fill" /></a>
          <a href="#"><Icon.YoutubeLogo size={22} weight="fill" /></a>
          <a href="#"><Icon.PinterestLogo size={22} weight="fill" /></a>
        </div>
      </div>

      <style jsx>{`
        .footer-wrapper {
          background: #fafafa;
          padding: 40px 20px 90px;
          border-top: 1px solid #eee;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 30px;
        }

        .footer-col {
          font-size: 14px;
          color: #333;
        }

        .footer-logo img {
          width: 130px;
          margin-bottom: 12px;
        }

        /* 👉 Shift contact details slightly right */
        .footer-contact {
          margin-left: 20px;
        }

        .footer-title {
          font-weight: 700;
          font-size: 16px;
          margin-bottom: 12px;
        }

        .footer-link {
          display: block;
          margin: 6px 0;
          color: #000;
          text-decoration: none;
          transition: 0.2s;
        }

        .footer-link:hover {
          opacity: 0.6;
        }

        .footer-contact p,
        .footer-col p {
          margin: 6px 0;
          line-height: 20px;
        }

        .footer-contact a {
          color: #000;
          text-decoration: underline;
        }

        .footer-bottom {
          margin-top: 35px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 10px;
          font-size: 13px;
        }

        .footer-social {
          display: flex;
          gap: 14px;
        }

        .footer-social a {
          color: #000;
          transition: 0.2s;
        }

        .footer-social a:hover {
          opacity: 0.7;
        }

        @media (max-width: 480px) {
          .footer-wrapper {
            padding-bottom: 120px;
          }
        }
      `}</style>
    </footer>
  );
}

export default Footer;



